// Shared Emerald paint for the board and round history: team gradients as
// clipped text fills and the pencil stroke. The UI font is the page's font
// (fonts.body in customTheme.ts).
export type TeamKey = 'team1' | 'team2';

export const gradientText = (image: string) => ({
  backgroundImage: image,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
});

// Team fills as drawn on the board: gold stops at 24/52%, pink at 25/58%.
export const TEAM_GRADIENT: Record<TeamKey, string> = {
  team1:
    'linear-gradient(180deg, var(--spades-grad-gold-1) 0%, var(--spades-grad-gold-2) 24%, var(--spades-grad-gold-3) 52%, var(--spades-grad-gold-4) 100%)',
  team2:
    'linear-gradient(180deg, var(--spades-grad-pink-1) 0%, var(--spades-pink-light) 25%, var(--spades-pink) 58%, var(--spades-pink-dark) 100%)',
};
// Team 1's label and Team bid use the brighter "gold alt" ramp.
export const TEAM_LABEL_GRADIENT: Record<TeamKey, string> = {
  team1:
    'linear-gradient(180deg, var(--spades-grad-gold-alt-1) 0%, var(--spades-grad-gold-alt-2) 35%, var(--spades-grad-gold-alt-3) 100%)',
  team2: TEAM_GRADIENT.team2,
};
// Team made reads its colours from the Spades · Team mode (data-team), at
// the same points as TEAM_GRADIENT (--spades-team-stop-*, customTheme.ts).
export const TEAM_MODE_GRADIENT =
  'linear-gradient(180deg, var(--spades-team-grad-1) 0%, var(--spades-team-grad-2) var(--spades-team-stop-2), var(--spades-team-grad-3) var(--spades-team-stop-3), var(--spades-team-grad-4) 100%)';

export const teamNumber = (team: string) => (team === 'team1' ? '1' : '2');

/** Shared value size for round-history bids/made and the breakdown. */
export const SUMMARY_VALUE_FONT_SIZE = 'calc(var(--spades-font-size-md) + 2px)';
/** Team totals sit one step above player values. */
export const SUMMARY_TEAM_VALUE_FONT_SIZE = `calc(${SUMMARY_VALUE_FONT_SIZE} + 2px)`;
/** Figma's pencils: a 1.6pt stroke at 9 and 12pt, in lucide's 24 grid. */
export const PENCIL_STROKE = 3.25;

/** Figma's minus sign (U+2212), so "−70" lines up with "+70". */
const MINUS = '−';

/** A round delta: "+81", "0", "−70". */
export const formatSigned = (value = 0) =>
  value > 0 ? `+${value}` : value < 0 ? `${MINUS}${-value}` : '0';

/** A running total: "162", "−59". */
export const formatTotal = (value = 0) =>
  value < 0 ? `${MINUS}${-value}` : `${value}`;
